// extracted by mini-css-extract-plugin
export default {"login":"login_login__S4+5n","card":"login_card__xmrQM","error":"login_error__qNCv4","footer":"login_footer__Idoec"};